import TextField from '../../../../sharedComponent/TextField/TextField'
const EmailReport = ({formik}: any) => {
  return (
    <div>
      <h4 className='fs-3 text-gray-800 fw-bolder'>Email Report</h4>
      <p className='text-gray-500 fs-7 fw-semibold'>All reports will be in Eastern Time (ET)</p>
      <div className='pb-7'>
        <TextField
          fieldTitle={'Subject'}
          filedTitleMandatory={true}
          fieldName={'subject'}
          placeHolder={'Enter Subject'}
          maxLength={'250'}
          handleOnChange={(e: any, name: string) => {
            formik.setFieldValue(name, e.target.value)
          }}
          formik={formik}
        />
      </div>

      <TextField
        fieldTitle={'Email IDs'}
        filedTitleMandatory={true}
        fieldName={'emailId'}
        placeHolder={'e.g foo@example.com, joe@example.com'}
        handleOnChange={(e: any, name: string) => {
          formik.setFieldValue(name, e.target.value)
        }}
        formik={formik}
      />
    </div>
  )
}
export default EmailReport
